import { ChakraProvider } from "@chakra-ui/react";
import { PostHogProvider } from "posthog-js/react";
import AuthProvider from "providers/AuthProvider";
import React from "react";
import { QueryClientProvider } from "react-query";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { QueryService } from "services/query.service";
import useAuth from "views/auth/hook/useAuth";
import "./assets/css/App.css";
import { envConfig } from "./config/env.config";
import theme from "./theme/theme";

function Renderer() {
  const queryClient = QueryService.getQueryClient();
  const hashParams = new URLSearchParams(window.location.hash.substring(1));
  const distinctId: string | undefined = hashParams.get("distinct_id");
  const sessionId: string | undefined = hashParams.get("session_id");

  const posthogBootstrapOptions =
    sessionId || distinctId
      ? {
          bootstrap: {
            ...(sessionId && { sessionID: sessionId }),
            ...(distinctId && { distinctID: distinctId }),
          },
        }
      : {};

  // Auth hooks
  useAuth();

  return (
    <ChakraProvider theme={theme}>
      <QueryClientProvider client={queryClient}>
        <React.StrictMode>
          <PostHogProvider
            apiKey={envConfig.postHogKey}
            options={{
              api_host: envConfig.postHogHost,
              debug: process.env.NODE_ENV === "development",
              ...posthogBootstrapOptions,
            }}
          >
            <ToastContainer
              position="bottom-left"
              autoClose={5000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="colored"
            />
            <BrowserRouter>
              <Switch>
                <Route path={`/`} component={AuthProvider} />
                {/* <Redirect from="/" to="/admin" /> */}
              </Switch>
            </BrowserRouter>
          </PostHogProvider>
        </React.StrictMode>
      </QueryClientProvider>
    </ChakraProvider>
  );
}

export default Renderer;
